import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira_list_single_line_row_height_targeting');
	},
};
